import { SectionBreakdownChart } from "@/components/Dashboard/MenuPerformance/SectionBreakdownChart";
import { useGetMenuPerformancesQuery } from "@/redux/services/dashboard/dashboard.api";

interface SectionBreakdownCardProps {
  restaurantId: string;
  startDate: string;
  endDate: string;
}

/**
 * Répartition par section, sized to sit half-width beside the orders
 * composition card — pie stacked above the legend, shorter canvas. Reuses the
 * menu_performances query already fetched elsewhere, so RTK Query serves it
 * from cache (SFRESTO-87).
 */
function SectionBreakdownCard({
  restaurantId,
  startDate,
  endDate,
}: SectionBreakdownCardProps) {
  const { data, isFetching } = useGetMenuPerformancesQuery(
    {
      restaurant_id: restaurantId,
      start_date: startDate,
      end_date: endDate,
      compare: true,
    },
    { skip: !restaurantId },
  );

  return (
    <SectionBreakdownChart
      data={data?.data.current.menu_section_breakdown ?? []}
      previousData={data?.data.previous?.menu_section_breakdown}
      loading={isFetching}
      height={240}
      gridClassName="grid grid-cols-1 sm:grid-cols-2 items-center gap-4"
    />
  );
}

export default SectionBreakdownCard;
